import i18n from "@/i18n";

export function formatBooleanAsAffirmative(value) {
    return value ? i18n.t("Helpers.Boolean.yes") : i18n.t("Helpers.Boolean.no");
}